// extracted by mini-css-extract-plugin
export default {"products":"KB-z","card":"LB-z","oosMessaging":"MB-z"};